<template>
  <ModalBlock v-model="modalCreate" :model="modalCreate">
    <div :class="style.modalCreate">
      <div :class="style.header">
        <span :class="style.namePopup">Добавить интеграцию</span>
        <SelectBase
          :text="selectedCategoryModal"
          :items="selectItems"
          :stylePopup="{
            width: '472px'
          }"
          @select="handleSelectCategoryModal"
        />
      </div>
      <div :class="style.integrationList">
        <IntegrationCard
          v-for="(integration, index) in filteredIntegrationNames"
          :key="integration"
          :isLast="index === filteredIntegrationNames.length - 1"
          :integrationKey="integration"
          :integrationData="getIntegration[integration]"
          :icon="plusIcon"
          :isEdit="true"
          @action="openCreate(integration)"
        />
      </div>
    </div>
  </ModalBlock>

  <ModalBlock
    v-model="modalSettingIntegration"
    :model="modalSettingIntegration"
  >
    <SettingIntegrationIDent
      v-if="selectIntegration === 'ident'"
      @closeModal="closeEditModal"
    />
    <SettingIntegrationMacDent
      v-if="selectIntegration === 'macDent'"
      @closeModal="closeEditModal"
    />
    <SettingIntegrationDentalPro
      v-if="selectIntegration === 'dentalPro'"
      @closeModal="closeEditModal"
    />
    <SettingIntegrationEmail
      v-if="selectIntegration === 'email'"
      @closeModal="closeEditModal"
    />
    <SettingIntegrationTelegram
      v-if="selectIntegration === 'telegram'"
      @closeModal="closeEditModal"
    />
    <SettingIntegrationMax
      v-if="selectIntegration === 'max'"
      @closeModal="closeEditModal"
    />
    <SettingIntegrationAmoCRM
      v-if="selectIntegration === 'amoCrm'"
      @closeModal="closeEditModal"
    />
    <SettingIntegrationBitrixCRM
      v-if="selectIntegration === 'bitrixCrm'"
      @closeModal="closeEditModal"
    />
    <SettingIntegrationYandex
      v-if="selectIntegration === 'metric'"
      @closeModal="closeEditModal"
    />
    <SettingIntegrationWebSite
      v-if="selectIntegration === 'webSite'"
      @closeModal="closeEditModal"
    />
    <SettingIntegrationGoogle
      v-if="selectIntegration === 'google'"
      @closeModal="closeEditModal"
    />
    <SettingIntegrationCBKiller
      v-if="selectIntegration === 'cbkiller'"
      @closeModal="closeEditModal"
    />
    <SettingIntegrationDomain
      v-if="selectIntegration === 'domain'"
      @closeModal="closeEditModal"
    />
    <SettingIntegrationExternalLink
      v-if="selectIntegration === 'externalLink'"
      @closeModal="closeEditModal"
    />
  </ModalBlock>

  <ModalBlock v-model="modalEditIntegration" :model="modalEditIntegration">
    <SettingIntegrationIDent
      v-if="selectIntegration === 'ident'"
      :edit="true"
      :integration-index="selectedIntegrationNum"
      :integration="getIntegrationByNameTyped().ident"
      @delete="openDeleteModal(selectIntegration, selectedIntegrationNum)"
      @closeModal="closeEditModal"
    />
    <SettingIntegrationMacDent
      v-if="selectIntegration === 'macDent'"
      :edit="true"
      :integration-index="selectedIntegrationNum"
      :integration="getIntegrationByNameTyped().macDent"
      @delete="openDeleteModal(selectIntegration, selectedIntegrationNum)"
      @closeModal="closeEditModal"
    />
    <SettingIntegrationDentalPro
      v-if="selectIntegration === 'dentalPro'"
      :edit="true"
      :integration-index="selectedIntegrationNum"
      :integration="getIntegrationByNameTyped().dentalPro"
      @delete="openDeleteModal(selectIntegration, selectedIntegrationNum)"
      @closeModal="closeEditModal"
    />
    <SettingIntegrationEmail
      v-if="selectIntegration === 'email'"
      :edit="true"
      :integration-index="selectedIntegrationNum"
      :integration="getIntegrationByName() as string"
      @delete="openDeleteModal(selectIntegration, selectedIntegrationNum)"
      @closeModal="closeEditModal"
    />
    <SettingIntegrationTelegram
      v-if="selectIntegration === 'telegram'"
      :edit="true"
      :integration-index="selectedIntegrationNum"
      :integration="getIntegrationByNameTyped().telegram"
      @delete="openDeleteModal(selectIntegration, selectedIntegrationNum)"
      @closeModal="closeEditModal"
    />
    <SettingIntegrationMax
      v-if="selectIntegration === 'max'"
      :edit="true"
      :integration-index="selectedIntegrationNum"
      :integration="getIntegrationByNameTyped().max"
      @delete="openDeleteModal(selectIntegration, selectedIntegrationNum)"
      @closeModal="closeEditModal"
    />
    <SettingIntegrationAmoCRM
      v-if="selectIntegration === 'amoCrm'"
      :edit="true"
      :integration-index="selectedIntegrationNum"
      :integration="getIntegrationByNameTyped().amoCrm"
      @delete="openDeleteModal(selectIntegration, selectedIntegrationNum)"
      @closeModal="closeEditModal"
    />
    <SettingIntegrationBitrixCRM
      v-if="selectIntegration === 'bitrixCrm'"
      :edit="true"
      :integration-index="selectedIntegrationNum"
      :integration="getIntegrationByNameTyped().bitrixCrm"
      @delete="openDeleteModal(selectIntegration, selectedIntegrationNum)"
      @closeModal="closeEditModal"
    />
    <SettingIntegrationYandex
      v-if="selectIntegration === 'metric'"
      :edit="true"
      :integration-index="selectedIntegrationNum"
      :integration="getIntegrationByNameTyped().metric"
      @delete="openDeleteModal(selectIntegration, selectedIntegrationNum)"
      @closeModal="closeEditModal"
    />
    <SettingIntegrationWebSite
      v-if="selectIntegration === 'webSite'"
      :edit="true"
      :integration-index="selectedIntegrationNum"
      :integration="getIntegrationByNameTyped().webSite"
      @delete="openDeleteModal(selectIntegration, selectedIntegrationNum)"
      @closeModal="closeEditModal"
    />
    <SettingIntegrationGoogle
      v-if="selectIntegration === 'google'"
      :edit="true"
      @delete="openDeleteModal(selectIntegration, selectedIntegrationNum)"
      @closeModal="closeEditModal"
    />
    <SettingIntegrationCBKiller
      v-if="selectIntegration === 'cbkiller'"
      :edit="true"
      :integration-index="selectedIntegrationNum"
      :integration="getIntegrationByNameTyped().cbkiller"
      @delete="openDeleteModal(selectIntegration, selectedIntegrationNum)"
      @closeModal="closeEditModal"
    />
    <SettingIntegrationDomain
      v-if="selectIntegration === 'domain'"
      :edit="true"
      :integration-index="selectedIntegrationNum"
      :integration="getIntegrationByNameTyped().domain"
      @delete="openDeleteModal(selectIntegration, selectedIntegrationNum)"
      @closeModal="closeEditModal"
    />
    <SettingIntegrationExternalLink
      v-if="selectIntegration === 'externalLink'"
      :edit="true"
      :integration-index="selectedIntegrationNum"
      :integration="getIntegrationByNameTyped().externalLink"
      @delete="openDeleteModal(selectIntegration, selectedIntegrationNum)"
      @closeModal="closeEditModal"
    />
  </ModalBlock>

  <DeleteIntegration :data="deleteModal" @close="deleteModal.open = false" />

  <SectionHeaderBlock title="Интеграции" :class="style.sectionHeader">
    <template #buttons>
      <PrimaryButton text="Добавить" @click="openModalCreate" />
    </template>
  </SectionHeaderBlock>

  <div :class="style.wrapper">
    <div :class="style.nav">
      <TabPanel
        text="Все"
        @click="setSelect('Все')"
        :active="selectedCategory === 'Все'"
      />
      <TabPanel
        text="МИС"
        @click="setSelect('МИС')"
        :active="selectedCategory === 'МИС'"
      />
      <TabPanel
        text="Уведомления"
        @click="setSelect('Уведомления')"
        :active="selectedCategory === 'Уведомления'"
      />
      <TabPanel
        text="Аналитика"
        @click="setSelect('Аналитика')"
        :active="selectedCategory === 'Аналитика'"
      />
      <TabPanel
        text="Другое"
        @click="setSelect('Другое')"
        :active="selectedCategory === 'Другое'"
      />
    </div>
  </div>

  <div :class="style.integrationList" v-if="getSortIntegrations !== 'await'">
    <template v-for="([key, data], index) in filteredIntegrations" :key="key">
      <IntegrationCard
        v-for="(item, num) in data.integration"
        :isLast="index === filteredIntegrations.length - 1"
        :key="`${key}-${num}`"
        :integrationKey="key"
        :integrationData="data"
        :item="item"
        :active="getActiveIntegration([key, data], num)"
        :icon="editIcon"
        @action="openEdit(key, num)"
      />
    </template>
  </div>
</template>

<script lang="ts">
import style from "./IntegrationComponent.module.scss";
import {defineComponent} from "vue";
import {
  integrationItem,
  integratioObj,
  sortIntegrationItem,
  newAmoData,
  identIntegration,
  macDentIntegration,
  dentalProIntegration,
  telegramIntegration,
  maxIntegration,
  amoCrm,
  bitrixCrmIntegration,
  metricIntegration,
  externalLinkIntegration,
  domainIntegration,
  cbKillerIntegration
} from "./IntegrationTypes";
import editIcon from "$images/icons/button/Name=Edit, Size=16, Tone=Default.svg";
import plusIcon from "$images/icons/button/Name=Plus, Size=16, Tone=Default.svg";
import ModalBlock from "@/layout/nav/components/modal/ModalBlock.vue";
import SelectBase from "@/elements/UI/select/SelectBase.vue";
import IntegrationCard from "@/page/setting/integration/IntegrationCard.vue";
import SettingIntegrationIDent from "@/page/setting/integration/settingIntegrations/SettingIntegrationIDent.vue";
import SettingIntegrationMacDent from "@/page/setting/integration/settingIntegrations/SettingIntegrationMacDent.vue";
import SettingIntegrationDentalPro from "@/page/setting/integration/settingIntegrations/SettingIntegrationDentalPro.vue";
import SettingIntegrationEmail from "@/page/setting/integration/settingIntegrations/SettingIntegrationEmail.vue";
import SettingIntegrationTelegram from "@/page/setting/integration/settingIntegrations/SettingIntegrationTelegram.vue";
import SettingIntegrationMax from "@/page/setting/integration/settingIntegrations/SettingIntegrationMax.vue";
import SettingIntegrationAmoCRM from "@/page/setting/integration/settingIntegrations/SettingIntegrationAmoCRM.vue";
import SettingIntegrationBitrixCRM from "@/page/setting/integration/settingIntegrations/SettingIntegrationBitrixCRM.vue";
import SettingIntegrationYandex from "@/page/setting/integration/settingIntegrations/SettingIntegrationYandex.vue";
import SettingIntegrationWebSite from "@/page/setting/integration/settingIntegrations/SettingIntegrationWebSite.vue";
import SettingIntegrationGoogle from "@/page/setting/integration/settingIntegrations/SettingIntegrationGoogle.vue";
import SettingIntegrationCBKiller from "@/page/setting/integration/settingIntegrations/SettingIntegrationCBKiller.vue";
import SettingIntegrationDomain from "@/page/setting/integration/settingIntegrations/SettingIntegrationDomain.vue";
import SettingIntegrationExternalLink from "@/page/setting/integration/settingIntegrations/SettingIntegrationExternalLink.vue";
import DeleteIntegration from "@/page/setting/integration/DeleteIntegration.vue";
import TabPanel from "@/elements/UI/tabs/TabPanel/TabPanel.vue";
import PrimaryButton from "@/elements/UI/button/ButtonStyle/Default/primary/PrimaryButton.vue";
import SectionHeaderBlock from "@/elements/UI/section/SectionHeaderBlock/SectionHeaderBlock.vue";
import {API} from "@/api/generated";

type DeleteModal = {
  open: boolean;
  name: string;
  num: number;
};

type IntegrationStoreItem = {
  category?: string;
  logo?: string;
  integration?: Array<integrationItem | string>;
  info?: unknown;
  [key: string]: unknown;
};

type IntegrationStoreMap = Record<string, IntegrationStoreItem>;

type SortIntegrationsValue = [string, sortIntegrationItem][] | "await";

type SelectCategoryPayload = {
  item: {
    text: string;
    icon?: string;
    value?: string | number | boolean | object | null;
  };
  index: number;
  value: string | number | boolean | object | null;
};

export default defineComponent({
  name: "IntegrationList",
  components: {
    SectionHeaderBlock,
    PrimaryButton,
    TabPanel,
    DeleteIntegration,
    SettingIntegrationExternalLink,
    SettingIntegrationDomain,
    SettingIntegrationCBKiller,
    SettingIntegrationGoogle,
    SettingIntegrationWebSite,
    SettingIntegrationYandex,
    SettingIntegrationBitrixCRM,
    SettingIntegrationAmoCRM,
    SettingIntegrationTelegram,
    SettingIntegrationMax,
    SettingIntegrationEmail,
    SettingIntegrationDentalPro,
    SettingIntegrationMacDent,
    SettingIntegrationIDent,
    IntegrationCard,
    SelectBase,
    ModalBlock
  },
  data() {
    return {
      style,
      openArrayIntegration: [] as string[],
      selectedCategory: "Все",
      selectedCategoryModal: "Все",
      amoErr: [] as string[][],
      globalErrAmo: false,
      editIcon,
      plusIcon,
      modalCreate: false,
      modalSettingIntegration: false,
      modalEditIntegration: false,
      selectIntegration: "",
      selectedIntegrationNum: 0,
      deleteModal: {
        open: false,
        name: "",
        num: 0
      } as DeleteModal
    };
  },
  async mounted() {
    await this.handleOAuthCallback();
  },
  methods: {
    async handleOAuthCallback(): Promise<void> {
      if (!this.$route.query.code) {
        return;
      }

      const integration = localStorage.getItem("integration");

      if (integration === "google") {
        await this.handleGoogleAuthCallback();
        return;
      }

      if (integration === "amo") {
        await this.handleAmoAuthCallback();
      }
    },

    async handleGoogleAuthCallback(): Promise<void> {
      try {
        const code = this.getQueryString(this.$route.query.code);

        if (!code) {
          return;
        }

        const {data} = await API.codeProcessing({
          body: {
            query: {code}
          }
        });

        if (!data) {
          this.clearOAuthState();
          return;
        }

        if (!this.getIntegration.google) {
          this.getIntegration.google = {
            category: "Аналитика",
            integration: []
          };
        }

        if (!Array.isArray(this.getIntegration.google.integration)) {
          this.getIntegration.google.integration = [];
        }

        this.getIntegration.google.integration.push(data);

        this.clearOAuthState();
      } catch (e) {
        console.error("Google auth error", e);
      }
    },

    async handleAmoAuthCallback(): Promise<void> {
      const code = this.getQueryString(this.$route.query.code);
      const referer = this.getQueryString(this.$route.query.referer);

      if (!code || !referer) {
        console.error("Amo auth error", "Не все данные переданы");
        return;
      }

      try {
        const data = await API.setAmoData({
          body: {
            code,
            referer,
            oauthClientId:
              localStorage.getItem("amoOauthClientId") || undefined,
            redirectUri: localStorage.getItem("amoRedirectUri") || undefined
          }
        });
        if (!data) {
          return;
        }
        this.upsertAmoIntegration(data);
        this.clearOAuthState();
      } catch (e) {
        console.error("Amo auth error", e);
      }
    },

    getQueryString(value: unknown): string {
      if (Array.isArray(value)) {
        return typeof value[0] === "string" ? value[0] : "";
      }

      return typeof value === "string" ? value : "";
    },

    clearOAuthState(): void {
      localStorage.removeItem("integration");
      localStorage.removeItem("amoOauthClientId");
      localStorage.removeItem("amoRedirectUri");
      void this.$router.replace("/user/integration");
    },

    upsertAmoIntegration(data: amoCrm): void {
      if (!this.getIntegration.amoCrm) {
        this.getIntegration.amoCrm = {
          category: "Уведомления",
          integration: []
        };
      }

      if (!Array.isArray(this.getIntegration.amoCrm.integration)) {
        this.getIntegration.amoCrm.integration = [];
      }

      const currentIndex = this.getIntegration.amoCrm.integration.findIndex(
        (item) => {
          if (!item || typeof item !== "object") {
            return false;
          }

          const amo = item as amoCrm;

          return (
            (data._id && amo._id === data._id) ||
            (data.refreshToken && amo.refreshToken === data.refreshToken) ||
            (data.client?.name && amo.client?.name === data.client.name)
          );
        }
      );

      if (currentIndex >= 0) {
        this.getIntegration.amoCrm.integration[currentIndex] = data;
        return;
      }

      this.getIntegration.amoCrm.integration.push(data);
    },

    handleSelectCategoryModal(payload: SelectCategoryPayload): void {
      if (typeof payload.value !== "string") {
        return;
      }

      this.selectedCategoryModal = payload.value;
    },
    closeEditModal(): void {
      this.modalEditIntegration = false;
      this.modalSettingIntegration = false;
    },

    openDeleteModal(name: string, num: number): void {
      this.modalEditIntegration = false;
      this.deleteModal = {
        open: true,
        name,
        num
      };
    },

    getIntegrationByNameTyped(): {
      ident?: identIntegration;
      macDent?: macDentIntegration;
      dentalPro?: dentalProIntegration;
      telegram?: telegramIntegration;
      max?: maxIntegration;
      amoCrm?: amoCrm;
      bitrixCrm?: bitrixCrmIntegration;
      metric?: metricIntegration;
      externalLink?: externalLinkIntegration;
      domain?: domainIntegration;
      webSite?: string;
      cbkiller?: cbKillerIntegration;
    } {
      const item = this.getIntegrationByName();

      return {
        ident:
          this.selectIntegration === "ident"
            ? (item as identIntegration)
            : undefined,
        macDent:
          this.selectIntegration === "macDent"
            ? (item as macDentIntegration)
            : undefined,
        dentalPro:
          this.selectIntegration === "dentalPro"
            ? (item as dentalProIntegration)
            : undefined,
        telegram:
          this.selectIntegration === "telegram"
            ? (item as telegramIntegration)
            : undefined,
        max:
          this.selectIntegration === "max"
            ? (item as maxIntegration)
            : undefined,
        amoCrm:
          this.selectIntegration === "amoCrm" ? (item as amoCrm) : undefined,
        bitrixCrm:
          this.selectIntegration === "bitrixCrm"
            ? (item as bitrixCrmIntegration)
            : undefined,
        metric:
          this.selectIntegration === "metric"
            ? (item as metricIntegration)
            : undefined,
        externalLink:
          this.selectIntegration === "externalLink"
            ? (item as externalLinkIntegration)
            : undefined,
        domain:
          this.selectIntegration === "domain"
            ? (item as domainIntegration)
            : undefined,
        webSite:
          this.selectIntegration === "webSite" ? (item as string) : undefined,
        cbkiller:
          this.selectIntegration === "cbkiller"
            ? (item as cbKillerIntegration)
            : undefined
      };
    },

    openCreate(integration: string): void {
      this.modalSettingIntegration = true;
      this.modalCreate = false;
      this.selectIntegration = integration;
      this.selectedIntegrationNum = 0;
    },

    openEdit(integration: string, num: number): void {
      this.modalEditIntegration = true;
      this.selectIntegration = integration;
      this.selectedIntegrationNum = num;
    },

    openModalCreate(): void {
      this.modalCreate = !this.modalCreate;
    },

    getErrDomain(info: {ip: boolean; ssl: boolean}): string[] {
      return [
        info.ip ? "" : "Не верный ip",
        info.ssl ? "" : "Сертификат безопасности не найден"
      ].filter(Boolean);
    },

    closeOpenIntegration(data: string): void {
      const index = this.openArrayIntegration.indexOf(data);
      if (index > -1) {
        this.openArrayIntegration.splice(index, 1);
      } else {
        this.openArrayIntegration.push(data);
      }
    },

    getActiveIntegration(
      dataIntegration: [string, sortIntegrationItem],
      num: number
    ): boolean {
      return this.openArrayIntegration.includes(dataIntegration[0] + "-" + num);
    },

    async fixAmo(data: [string, sortIntegrationItem]): Promise<void> {
      const name = data[0];
      const num = data[1].num;

      if (
        this.amoErr[num]?.includes("нет доступа к амо") ||
        this.amoErr[num]?.includes("Был потерян доступ к амо")
      ) {
        this.globalErrAmo = true;
        return;
      }

      const amo = this.getIntegration[name]?.integration?.[num] as
        {refreshToken?: string} | undefined;

      if (!amo?.refreshToken) {
        return;
      }
      const dataByRefreshToken = await API.getAgainData({
        query: {refreshToken: amo.refreshToken}
      });
      if (!dataByRefreshToken) {
        return;
      }
      this.getIntegration[name].integration![num] = dataByRefreshToken;
    },

    validAmo(data: newAmoData[]): void {
      data.forEach((amo, index) => {
        if (this.amoErr[index] === undefined) {
          this.amoErr[index] = [];
        }

        this.amoErr[index] = [];

        if (amo?.error) {
          this.amoErr[index].push("Был потерян доступ к амо");
        }
        if (!amo?.refreshToken || !amo?.accessToken) {
          this.amoErr[index].push("нет доступа к амо");
        }
        if (!amo?.dealList) {
          this.amoErr[index].push("ошибка при получении данных о воронках amo");
        }
        if (!amo?.client?.name) {
          this.amoErr[index].push("ошибка при получении данных о клиенте amo");
        }
        if (amo?.mainPipelines === "" || amo?.mainStatus === "") {
          this.amoErr[index].push("выберете куда отправлять заявку");
        }
      });
    },

    getClassStatus(key: string, data: integratioObj): string {
      const arr: unknown[] = [];

      switch (key) {
        case "email":
          arr.push(data);
          break;
        case "ident":
          arr.push(data?.id);
          break;
        case "macDent":
          arr.push(data?.id);
          break;
        case "telegram":
        case "max":
          arr.push(data?.id, data?.name);
          break;
        case "metric":
          arr.push(data?.id);
          break;
        case "amoCrm":
          arr.push(
            data?.mainPipelines,
            data?.mainStatus,
            data?.dealList,
            data?.refreshToken,
            data?.accessToken,
            !data?.error
          );
          if (data?.client && "name" in data.client) {
            arr.push(data.client.name);
          }
          break;
        case "bitrixCrm":
          arr.push(data?.webhook);
          break;
        case "dentalPro":
          arr.push(data?.token, data?.secret);
          break;
        case "webSite":
          arr.push(data);
          break;
        case "domain":
          arr.push(data);
          break;
      }

      const newArr = arr.filter((item) => Boolean(item));

      if (arr.length !== newArr.length) {
        return style.status + " " + style.deactivation;
      }

      return style.status + " " + style.active;
    },

    getIntegrationByName(): integrationItem | string {
      const currentIntegration = this.getIntegration[this.selectIntegration];

      if (currentIntegration?.integration?.[this.selectedIntegrationNum]) {
        return currentIntegration.integration[this.selectedIntegrationNum] as
          integrationItem | string;
      }

      return "";
    },

    setSelect(select: string): void {
      this.selectedCategory = select;
    }
  },

  computed: {
    getIntegration(): IntegrationStoreMap {
      return (this.$integrationStore.getIntegration ??
        {}) as IntegrationStoreMap;
    },

    getCategoryList(): string[] {
      return (this.$integrationStore.getCategoryList ?? []) as string[];
    },

    getSortIntegrations(): SortIntegrationsValue {
      return (this.$integrationStore.getSortIntegrations ??
        "await") as SortIntegrationsValue;
    },

    getIntegrationName(): string[] {
      return (this.$integrationStore.getIntegrationName ?? []) as string[];
    },

    selectItems(): SelectItem[] {
      return this.getCategoryList.map((item: string) => {
        return {
          text: item,
          icon: "",
          value: item,
          variant: "tab"
        };
      });
    },

    filteredIntegrations(): [string, sortIntegrationItem][] {
      if (this.getSortIntegrations === "await") return [];

      if (this.selectedCategory === "Все") {
        return this.getSortIntegrations as [string, sortIntegrationItem][];
      }

      return (
        this.getSortIntegrations as [string, sortIntegrationItem][]
      ).filter(([, data]) => {
        return data.category === this.selectedCategory;
      });
    },

    filteredIntegrationNames(): string[] {
      const isDomainConnected = this.isDomainAlreadyConnected;

      if (this.selectedCategoryModal === "Все") {
        return this.getIntegrationName.filter((item) => {
          if (item === "domain" && isDomainConnected) return false;
          return true;
        });
      }

      return this.getIntegrationName.filter((name: string) => {
        const matchCategory =
          this.getIntegration[name]?.category === this.selectedCategoryModal;

        if (!matchCategory) return false;

        if (name === "domain" && isDomainConnected) return false;

        return true;
      });
    },

    isDomainAlreadyConnected(): boolean {
      const domain = this.getIntegration["domain"];
      return !!domain?.integration?.length;
    }
  },

  watch: {
    "getIntegration.amoCrm.integration"(data: newAmoData[] | undefined): void {
      if (Array.isArray(data)) {
        this.validAmo(data);
      }
    }
  }
});
</script>
